import { PermissionGroup } from ".";
import { AmorgUserRole } from '.';
import { IndividualMemberPermission } from '.';

export class PublicAmorgUser
{
    public individualPermissions: IndividualMemberPermission[] = [];

    constructor(
        public id: string,
        public firstname: string,
        public middlename: string,
        public lastname: string,
        public initials: string,
        public email: string,
        public enabled: boolean,
        public currentRole: AmorgUserRole | null,
        public permissionGroup: PermissionGroup,
        public settings: UserSettings,
        public created: Date
    ) { }
}

export type UserSettings = {
    articleContact: boolean;
};